export default "__VITE_ASSET__BvkyXTLi__"